var map = {
	"./BIOLOGIE MOLECULAIRE.svg": 126,
	"./EQUIPEMENT DE SÉCURITÉ LABORATOIRE.svg": 127,
	"./EQUIPEMENT ET MATÉRIEL SCINTIFIQUE.svg": 128,
	"./PESAGE.svg": 129,
	"./REACTIF ET PRODUIT CHIMIQUE.svg": 130,
	"./VERRERIE ET CONSOMMABLE DE LABO.svg": 131,
	"./home-feature.svg": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;